/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateFlowStateSubscriptionInput = {
    flowStateRelayId: string;
};
export type UpdateFlowStateSubscriptionVariables = {
    input: UpdateFlowStateSubscriptionInput;
};
export type UpdateFlowStateSubscriptionResponse = {
    readonly updateFlowState: {
        readonly flowState: {
            readonly id: string;
            readonly flowKey: string | null;
            readonly previousState: string | null;
            readonly current: {
                readonly state: string | null;
                readonly percentComplete: number | null;
                readonly errorMessage: string | null;
            } | null;
            readonly pending: {
                readonly state: string | null;
                readonly percentComplete: number | null;
                readonly errorMessage: string | null;
            } | null;
        } | null;
    };
};
export type UpdateFlowStateSubscription = {
    readonly response: UpdateFlowStateSubscriptionResponse;
    readonly variables: UpdateFlowStateSubscriptionVariables;
};



/*
subscription UpdateFlowStateSubscription(
  $input: UpdateFlowStateSubscriptionInput!
) {
  updateFlowState(input: $input) {
    flowState {
      id
      flowKey
      previousState
      current {
        state
        percentComplete
        errorMessage
        id
      }
      pending {
        state
        percentComplete
        errorMessage
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flowKey",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previousState",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentComplete",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
    } as any, v8 = [
        (v5 /*: any*/),
        (v6 /*: any*/),
        (v7 /*: any*/)
    ], v9 = [
        (v5 /*: any*/),
        (v6 /*: any*/),
        (v7 /*: any*/),
        (v2 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateFlowStateSubscription",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateFlowStateSubscriptionPayload",
                    "kind": "LinkedField",
                    "name": "updateFlowState",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlowState",
                            "kind": "LinkedField",
                            "name": "flowState",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStatus",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStatus",
                                    "kind": "LinkedField",
                                    "name": "pending",
                                    "plural": false,
                                    "selections": (v8 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Subscription",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateFlowStateSubscription",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateFlowStateSubscriptionPayload",
                    "kind": "LinkedField",
                    "name": "updateFlowState",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlowState",
                            "kind": "LinkedField",
                            "name": "flowState",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStatus",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": (v9 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStatus",
                                    "kind": "LinkedField",
                                    "name": "pending",
                                    "plural": false,
                                    "selections": (v9 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "abf25a30873989167588cda0fbfa0c94",
            "id": null,
            "metadata": {},
            "name": "UpdateFlowStateSubscription",
            "operationKind": "subscription",
            "text": "subscription UpdateFlowStateSubscription(\n  $input: UpdateFlowStateSubscriptionInput!\n) {\n  updateFlowState(input: $input) {\n    flowState {\n      id\n      flowKey\n      previousState\n      current {\n        state\n        percentComplete\n        errorMessage\n        id\n      }\n      pending {\n        state\n        percentComplete\n        errorMessage\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '19556be006590478ed4d7a35d7219b6f';
export default node;
